export const transformReturnShipmentOrderDto = returnShipmentOrder => ({
  id: returnShipmentOrder.id,
  totalAmount: returnShipmentOrder.total_amount,
  payableAmount: returnShipmentOrder.payable_amount,
  currency: returnShipmentOrder.currency
});